import produce from "immer"

import { LOGIN_ERROR, LOGIN_LOADING } from "./constants";

export const initialState = {
    loginError: null,
}

const loginReducer = (state = initialState, action) => 
    produce(state, (draft) => {
        // eslint-disable-next-line default-case
        switch (action.type) {
            case LOGIN_ERROR:
                draft.loginError = action.loginError;
                break;
        }
    });


export default loginReducer;
